import { get_media_url } from "../../../api/utils";
import CardContainer from "./cardcontainer";

const ImagePost = ({ post, ...props }) => {
  return (
    <CardContainer
      id={post.hid}
      className={"relative overflow-hidden bg-[#333333]"}
      {...props}
    >
      <img
        className="absolute top-0 left-0 w-full h-full object-cover"
        src={get_media_url(post.foreground_image)}
        alt="image_post"
      ></img>
    </CardContainer>
  );
};

export default ImagePost;
